<span class="author-name nordic-blue-900-text text-icon-primary font-body-1 medium-type font-label-medium">{{
  author
}}</span>
